import * as ProspectoProvider from "../providers/prospecto-provider";
import * as GeneralRepository from "../repositories/general-repository";

export const listarProspectos = async (idIntermediario) => {
    const response = await ProspectoProvider.listarProspectos(idIntermediario)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            prospectos: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await listarProspectos(idIntermediario)
            } else {
                return {
                    error: response.auditResponse,
                    prospectos: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                prospectos: null
            }
        }
    }
}

export const mostrarMensajeProspecto = async (idIntermediario, idProspecto) => {
    const response = await ProspectoProvider.mostrarMensajeProspecto(idIntermediario, idProspecto)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            mensaje: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await listarProspectos(idIntermediario)
            } else {
                return {
                    error: response.auditResponse,
                    mensaje: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                mensaje: null
            }
        }
    }
}